/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 16:57:55
 * @LastEditors: shenlin
 * @LastEditTime: 2022-05-23 11:39:37
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 活动列表查询
export const getActivityDataByPage = params =>
  request(BASE_URL + '/govactivityData/getActivityDataByPage', { params })
// 显示丽水市及各个区县数据
export const getArea = params => request(BASE_URL + '/govdictArea/getArea', { params })
// 获取报名记录列表
export const getSignRecordByPage = params =>
  request(BASE_URL + '/govactivityData/getSignRecordByPage', { params })
// 删除活动
export const deleteActivityData = params =>
  request(BASE_URL + '/govactivityData/deleteActivityData', { params })
// 新增活动
export const addActivityData = data =>
  request.post(BASE_URL + '/govactivityData/addActivityData', data)
// 修改活动
export const updateActivityData = data =>
  request.post(BASE_URL + '/govactivityData/updateActivityData', data)
// 活动详情
export const getActivityData = params => request(BASE_URL + '/govactivityData/getActivityData',  { params })
// 导出记录
export const exportRecording = params => request.downLoad(BASE_URL + '/govactivityData/exportRecording',  params)
// 文件上传
export const uploadFileByContentType = process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/uploadFileByContentType'
// 获取直播类型列表
export const getLiveTypeList = params => request(BASE_URL + '/govliveData/getLiveTypeList',  { params })
// 获取直播类型列表
export const syncActivityData = params => request(BASE_URL + '/govactivityData/syncActivityData',  { params })
